<template>
  <div class="sf-page">
    <information-dialog v-bind:dismissButtonLabel="$t('request')"
                        v-bind:title="$t('requestInvitationCode')"
                        v-model="forgotDialog"
                        v-on:dismiss="sendEmail">
      <p>Bitte geben Sie die E-Mail-Adresse ein, mit der Sie als Kunde oder Gast für die Messe registriert sind. Wir senden Ihnen Ihren persönlichen Einladungscode erneut zu. Bitte werfen Sie auch einen Blick in den Spam-Ordner Ihres E-Mail-Postfaches.</p>
      <v-text-field class="mb-2"
                    dense
                    hide-details="auto"
                    outlined
                    v-bind:label="$t('email')"
                    v-model="email" />
    </information-dialog>

    <div class="sf-container sf-home">
      <top-image-header gradient="to right, rgba(11, 43, 87, .94) 0%, rgba(11, 43, 87, .7) 50%, rgba(11, 43, 87, .25) 100%"
                        image-src="/images/header6.jpg"
                        v-bind:aspect-ratio="3.4">
        <div class="sf-home__hero">
          <div class="sf-home__eyebrow">SAGASSER</div>
          <h1 class="sf-hero__title white--text">{{ event.title }}</h1>
          <p class="sf-home__lead">{{ $t('orderPeriod', { start: $options.filters.formatDate(event.startDate, 'LLL'), end: $options.filters.formatDate(event.endDate, 'LLL') }) }}</p>
        </div>
      </top-image-header>

      <starting-soon-card v-bind:event="event"
                          v-on:signInCustomer="signIn"
                          v-on:signOutCustomer="signOutCustomer"
                          v-bind:error="error"
                          v-bind:loading="loading"
                          v-on:forgot="forgotDialog = true" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import TopImageHeader from '@/components/common/TopImageHeader'
  import StartingSoonCard from '@/components/StartingSoonCard'
  import InformationDialog from '@/components/common/InformationDialog'

  export default {
    components: {
      StartingSoonCard,
      TopImageHeader,
      InformationDialog
    },
    computed: {
      ...mapGetters([ 'event' ])
    },
    created() {
      if (this.$route.query.invitationCode != null) {
        if (this.$route.query.invitationCode.startsWith('CUS')) {
          this.signInCustomer(this.$route.query.invitationCode)
        } else {
          this.$router.push({ name: 'registration-supplier-design', params: { invitationCode: this.$route.query.invitationCode } })
        }
      }
    },
    data: () => ({
      error: false,
      loading: false,
      forgotDialog: false,
      email: null
    }),
    methods: {
      async sendEmail() {
        await this.$store.dispatch('resendInvitationCode', { email: this.email })

        console.log('sent email to ' + this.email)
      },
      async signIn(invitationCode) {
        if (invitationCode.startsWith('CUS')) {
          await this.signInCustomer(invitationCode)
        } else {
          this.$router.push({ name: 'registration-supplier-design', params: { invitationCode: invitationCode } })
        }
      },
      async signInCustomer(invitationCode) {
        this.loading = true

        try {
          await this.$store.dispatch('loadCustomerByInvitationCode', { invitationCode: invitationCode })
        } catch {
          this.loading = false
          this.error = true
        }

        const customer = this.$store.getters.customerByInvitationCode(invitationCode)

        this.loading = false

        if (customer == null) {
          this.error = true
          return
        }

        if (customer.state !== 'accepted') {
          this.error = true
          return
        }

        this.error = false

        await this.$store.dispatch('setCurrentCustomer', { customer })
      },
      async signOutCustomer() {
        await this.$store.dispatch('deleteCurrentCustomer')
      }
    },
    name: 'Home'
  }
</script>

<style scoped>
  .sf-home {
    padding-top: 24px;
  }

  .sf-home__hero {
    max-width: 560px;
  }

  .sf-home__eyebrow {
    color: rgba(255, 255, 255, .85);
    font-size: .8125rem;
    font-weight: 700;
    letter-spacing: .12em;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .sf-home__lead {
    color: rgba(255, 255, 255, .9);
    font-size: 1rem;
    margin: 8px 0 0;
  }

  @media (max-width: 599px) {
    .sf-home {
      padding-top: 16px;
    }
  }
</style>

<i18n>
  {
    "de": {
      "startingSoon": "Es ist bald soweit…",
      "requestInvitationCode": "Einladungscode anfordern",
      "request": "Anfordern",
      "email": "E-Mail-Adresse",
      "orderPeriod": "Bestellzeitraum: {start} bis {end}"
    },
    "en": {
      "startingSoon": "Starting soon…",
      "requestInvitationCode": "Request invitation code",
      "request": "Request",
      "email": "Email",
      "orderPeriod": "Order period: {start} to {end}"
    }
  }
</i18n>